/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meta V8 Over API Specification
 * OpenAPI spec version: 0.0.8
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ClusterInformationResponse,
  ClusterMapResponse,
  DeleteV8DatabaseInstanceDatabaseInstancesParams,
  InstanceCustomTagResponse,
  InstanceTargetResponse,
  InstanceTestConnectionResponse,
  InstanceTestDbConnectionRequestV8,
  OsClusterListResponse,
  OsClusterRequest,
  PlanAccountTestConnectionRequestV8,
  ResultResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary removeInstances
 */
export const deleteV8DatabaseInstanceDatabaseInstances = (
  params: MaybeRef<DeleteV8DatabaseInstanceDatabaseInstancesParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  params = unref(params);

  return customAxiosInstance<ResultResponse>(
    {
      url: `/api/v8/database-instance/database-instances`,
      method: 'DELETE',
      params: unref(params),
    },
    options,
  );
};

export const getDeleteV8DatabaseInstanceDatabaseInstancesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV8DatabaseInstanceDatabaseInstances>>,
    TError,
    { params: DeleteV8DatabaseInstanceDatabaseInstancesParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV8DatabaseInstanceDatabaseInstances>>,
  TError,
  { params: DeleteV8DatabaseInstanceDatabaseInstancesParams },
  TContext
> => {
  const mutationKey = ['deleteV8DatabaseInstanceDatabaseInstances'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV8DatabaseInstanceDatabaseInstances>>,
    { params: DeleteV8DatabaseInstanceDatabaseInstancesParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteV8DatabaseInstanceDatabaseInstances(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV8DatabaseInstanceDatabaseInstancesMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV8DatabaseInstanceDatabaseInstances>>
>;

export type DeleteV8DatabaseInstanceDatabaseInstancesMutationError = ErrorType<unknown>;

/**
 * @summary removeInstances
 */
export const useDeleteV8DatabaseInstanceDatabaseInstances = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV8DatabaseInstanceDatabaseInstances>>,
      TError,
      { params: DeleteV8DatabaseInstanceDatabaseInstancesParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof deleteV8DatabaseInstanceDatabaseInstances>>,
  TError,
  { params: DeleteV8DatabaseInstanceDatabaseInstancesParams },
  TContext
> => {
  const mutationOptions = getDeleteV8DatabaseInstanceDatabaseInstancesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getOsClusterList
 */
export const postV8DatabaseInstanceOsClusterList = (
  osClusterRequest: MaybeRef<OsClusterRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  osClusterRequest = unref(osClusterRequest);

  return customAxiosInstance<OsClusterListResponse>(
    {
      url: `/api/v8/database-instance/os-cluster-list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: osClusterRequest,
      signal,
    },
    options,
  );
};

export const getPostV8DatabaseInstanceOsClusterListMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8DatabaseInstanceOsClusterList>>,
    TError,
    { data: BodyType<OsClusterRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8DatabaseInstanceOsClusterList>>,
  TError,
  { data: BodyType<OsClusterRequest> },
  TContext
> => {
  const mutationKey = ['postV8DatabaseInstanceOsClusterList'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8DatabaseInstanceOsClusterList>>,
    { data: BodyType<OsClusterRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8DatabaseInstanceOsClusterList(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8DatabaseInstanceOsClusterListMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8DatabaseInstanceOsClusterList>>
>;
export type PostV8DatabaseInstanceOsClusterListMutationBody = BodyType<OsClusterRequest>;
export type PostV8DatabaseInstanceOsClusterListMutationError = ErrorType<unknown>;

/**
 * @summary getOsClusterList
 */
export const usePostV8DatabaseInstanceOsClusterList = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8DatabaseInstanceOsClusterList>>,
      TError,
      { data: BodyType<OsClusterRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8DatabaseInstanceOsClusterList>>,
  TError,
  { data: BodyType<OsClusterRequest> },
  TContext
> => {
  const mutationOptions = getPostV8DatabaseInstanceOsClusterListMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 인스턴스 ID 요청 + 요청 인자가 null이 아닌 경우 DB에 저장된 인스턴스 인자로 보안데이터 요청됨. 예시 데이터) password"
보안 인자값이 공백 혹은 채워져있을 경우 요청된 데이터로 요청됨"
보안 인자값이 null 값으로 요청될 경우 요청된 instanceId의 보안 인자로 요청됨.
 * @summary 인스턴스 DB 연결 테스트
 */
export const postV8DatabaseInstanceTestDbConnection = (
  instanceTestDbConnectionRequestV8: MaybeRef<InstanceTestDbConnectionRequestV8>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceTestDbConnectionRequestV8 = unref(instanceTestDbConnectionRequestV8);

  return customAxiosInstance<InstanceTestConnectionResponse>(
    {
      url: `/api/v8/database-instance/test-db-connection`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: instanceTestDbConnectionRequestV8,
      signal,
    },
    options,
  );
};

export const getPostV8DatabaseInstanceTestDbConnectionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8DatabaseInstanceTestDbConnection>>,
    TError,
    { data: BodyType<InstanceTestDbConnectionRequestV8> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8DatabaseInstanceTestDbConnection>>,
  TError,
  { data: BodyType<InstanceTestDbConnectionRequestV8> },
  TContext
> => {
  const mutationKey = ['postV8DatabaseInstanceTestDbConnection'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8DatabaseInstanceTestDbConnection>>,
    { data: BodyType<InstanceTestDbConnectionRequestV8> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8DatabaseInstanceTestDbConnection(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8DatabaseInstanceTestDbConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8DatabaseInstanceTestDbConnection>>
>;
export type PostV8DatabaseInstanceTestDbConnectionMutationBody =
  BodyType<InstanceTestDbConnectionRequestV8>;
export type PostV8DatabaseInstanceTestDbConnectionMutationError = ErrorType<unknown>;

/**
 * @summary 인스턴스 DB 연결 테스트
 */
export const usePostV8DatabaseInstanceTestDbConnection = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8DatabaseInstanceTestDbConnection>>,
      TError,
      { data: BodyType<InstanceTestDbConnectionRequestV8> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8DatabaseInstanceTestDbConnection>>,
  TError,
  { data: BodyType<InstanceTestDbConnectionRequestV8> },
  TContext
> => {
  const mutationOptions = getPostV8DatabaseInstanceTestDbConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getClusterInformation
 */
export const getV8DatabaseInstanceClusterInformationByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<ClusterInformationResponse>(
    { url: `/api/v8/database-instance/${instanceId}/cluster/information`, method: 'GET', signal },
    options,
  );
};

export const getGetV8DatabaseInstanceClusterInformationByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
) => {
  return ['api', 'v8', 'database-instance', instanceId, 'cluster', 'information'] as const;
};

export const getGetV8DatabaseInstanceClusterInformationByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DatabaseInstanceClusterInformationByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8DatabaseInstanceClusterInformationByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DatabaseInstanceClusterInformationByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8DatabaseInstanceClusterInformationByInstanceId>>
  > = ({ signal }) =>
    getV8DatabaseInstanceClusterInformationByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DatabaseInstanceClusterInformationByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV8DatabaseInstanceClusterInformationByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DatabaseInstanceClusterInformationByInstanceId>>
>;
export type GetV8DatabaseInstanceClusterInformationByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getClusterInformation
 */

export function useGetV8DatabaseInstanceClusterInformationByInstanceId<
  TData = Awaited<ReturnType<typeof getV8DatabaseInstanceClusterInformationByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8DatabaseInstanceClusterInformationByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DatabaseInstanceClusterInformationByInstanceIdQueryOptions(
    instanceId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getClusterMap
 */
export const getV8DatabaseInstanceClusterMapByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<ClusterMapResponse>(
    { url: `/api/v8/database-instance/${instanceId}/cluster/map`, method: 'GET', signal },
    options,
  );
};

export const getGetV8DatabaseInstanceClusterMapByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
) => {
  return ['api', 'v8', 'database-instance', instanceId, 'cluster', 'map'] as const;
};

export const getGetV8DatabaseInstanceClusterMapByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DatabaseInstanceClusterMapByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8DatabaseInstanceClusterMapByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DatabaseInstanceClusterMapByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8DatabaseInstanceClusterMapByInstanceId>>
  > = ({ signal }) =>
    getV8DatabaseInstanceClusterMapByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DatabaseInstanceClusterMapByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV8DatabaseInstanceClusterMapByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DatabaseInstanceClusterMapByInstanceId>>
>;
export type GetV8DatabaseInstanceClusterMapByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getClusterMap
 */

export function useGetV8DatabaseInstanceClusterMapByInstanceId<
  TData = Awaited<ReturnType<typeof getV8DatabaseInstanceClusterMapByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8DatabaseInstanceClusterMapByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DatabaseInstanceClusterMapByInstanceIdQueryOptions(
    instanceId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getCustomTags
 */
export const getV8DatabaseInstanceCustomTagsByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<InstanceCustomTagResponse>(
    { url: `/api/v8/database-instance/${instanceId}/custom-tags`, method: 'GET', signal },
    options,
  );
};

export const getGetV8DatabaseInstanceCustomTagsByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
) => {
  return ['api', 'v8', 'database-instance', instanceId, 'custom-tags'] as const;
};

export const getGetV8DatabaseInstanceCustomTagsByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DatabaseInstanceCustomTagsByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8DatabaseInstanceCustomTagsByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DatabaseInstanceCustomTagsByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8DatabaseInstanceCustomTagsByInstanceId>>
  > = ({ signal }) =>
    getV8DatabaseInstanceCustomTagsByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DatabaseInstanceCustomTagsByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV8DatabaseInstanceCustomTagsByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DatabaseInstanceCustomTagsByInstanceId>>
>;
export type GetV8DatabaseInstanceCustomTagsByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getCustomTags
 */

export function useGetV8DatabaseInstanceCustomTagsByInstanceId<
  TData = Awaited<ReturnType<typeof getV8DatabaseInstanceCustomTagsByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8DatabaseInstanceCustomTagsByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DatabaseInstanceCustomTagsByInstanceIdQueryOptions(
    instanceId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary testPlanAccountV8
 */
export const postV8DatabaseInstancePlanAccountTestConnectionByInstanceId = (
  instanceId: MaybeRef<string>,
  planAccountTestConnectionRequestV8: MaybeRef<PlanAccountTestConnectionRequestV8>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  planAccountTestConnectionRequestV8 = unref(planAccountTestConnectionRequestV8);

  return customAxiosInstance<InstanceTestConnectionResponse>(
    {
      url: `/api/v8/database-instance/${instanceId}/plan-account/test-connection`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: planAccountTestConnectionRequestV8,
      signal,
    },
    options,
  );
};

export const getPostV8DatabaseInstancePlanAccountTestConnectionByInstanceIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8DatabaseInstancePlanAccountTestConnectionByInstanceId>>,
    TError,
    { instanceId: string; data: BodyType<PlanAccountTestConnectionRequestV8> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8DatabaseInstancePlanAccountTestConnectionByInstanceId>>,
  TError,
  { instanceId: string; data: BodyType<PlanAccountTestConnectionRequestV8> },
  TContext
> => {
  const mutationKey = ['postV8DatabaseInstancePlanAccountTestConnectionByInstanceId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8DatabaseInstancePlanAccountTestConnectionByInstanceId>>,
    { instanceId: string; data: BodyType<PlanAccountTestConnectionRequestV8> }
  > = (props) => {
    const { instanceId, data } = props ?? {};

    return postV8DatabaseInstancePlanAccountTestConnectionByInstanceId(
      instanceId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8DatabaseInstancePlanAccountTestConnectionByInstanceIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8DatabaseInstancePlanAccountTestConnectionByInstanceId>>
>;
export type PostV8DatabaseInstancePlanAccountTestConnectionByInstanceIdMutationBody =
  BodyType<PlanAccountTestConnectionRequestV8>;
export type PostV8DatabaseInstancePlanAccountTestConnectionByInstanceIdMutationError =
  ErrorType<unknown>;

/**
 * @summary testPlanAccountV8
 */
export const usePostV8DatabaseInstancePlanAccountTestConnectionByInstanceId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8DatabaseInstancePlanAccountTestConnectionByInstanceId>>,
      TError,
      { instanceId: string; data: BodyType<PlanAccountTestConnectionRequestV8> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8DatabaseInstancePlanAccountTestConnectionByInstanceId>>,
  TError,
  { instanceId: string; data: BodyType<PlanAccountTestConnectionRequestV8> },
  TContext
> => {
  const mutationOptions =
    getPostV8DatabaseInstancePlanAccountTestConnectionByInstanceIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getTargetCheck
 */
export const getV8DatabaseInstanceTargetCheckByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<InstanceTargetResponse>(
    { url: `/api/v8/database-instance/${instanceId}/target-check`, method: 'GET', signal },
    options,
  );
};

export const getGetV8DatabaseInstanceTargetCheckByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
) => {
  return ['api', 'v8', 'database-instance', instanceId, 'target-check'] as const;
};

export const getGetV8DatabaseInstanceTargetCheckByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DatabaseInstanceTargetCheckByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8DatabaseInstanceTargetCheckByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DatabaseInstanceTargetCheckByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8DatabaseInstanceTargetCheckByInstanceId>>
  > = ({ signal }) =>
    getV8DatabaseInstanceTargetCheckByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DatabaseInstanceTargetCheckByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV8DatabaseInstanceTargetCheckByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DatabaseInstanceTargetCheckByInstanceId>>
>;
export type GetV8DatabaseInstanceTargetCheckByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getTargetCheck
 */

export function useGetV8DatabaseInstanceTargetCheckByInstanceId<
  TData = Awaited<ReturnType<typeof getV8DatabaseInstanceTargetCheckByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8DatabaseInstanceTargetCheckByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DatabaseInstanceTargetCheckByInstanceIdQueryOptions(
    instanceId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
